// Paleta de los charts de reportes.
//
// Validada con el validador de la skill de dataviz (no a ojo):
//   light #2a78d6,#eda100,#1baf7a → lightness OK · chroma OK ·
//     CVD ΔE 9.1 (protan, peor par) · normal ΔE 22.9 · contraste WARN
//   dark  #3987e5,#c98500,#199e70 → todo PASS
//
// El WARN de contraste en claro (amarillo y aqua < 3:1 contra la superficie)
// NO es descartable: obliga a relieve. Lo cubrimos con las dos cosas que el
// metodo acepta: labels directos sobre cada barra y la tabla de datos debajo
// del chart, que ademas es la vista accesible.
//
// Las hues se asignan en orden FIJO por identidad de la serie, nunca cicladas
// ni por ranking: si un filtro cambia que series hay, las que quedan no se
// repintan.

export interface SeriesStyle {
  key: string;
  label: string;
  light: string;
  dark: string;
}

export const REPORT_SERIES: readonly SeriesStyle[] = [
  { key: 'net', label: 'Neto', light: '#2a78d6', dark: '#3987e5' },
  { key: 'vat', label: 'IVA', light: '#eda100', dark: '#c98500' },
  { key: 'revenue', label: 'Devengado', light: '#1baf7a', dark: '#199e70' },
] as const;

export function seriesColor(key: string, mode: 'light' | 'dark'): string {
  const s = REPORT_SERIES.find((x) => x.key === key);
  if (!s) return mode === 'dark' ? '#c3c2b7' : '#52514e';
  return mode === 'dark' ? s.dark : s.light;
}

export function seriesLabel(key: string): string {
  return REPORT_SERIES.find((x) => x.key === key)?.label ?? key;
}

/** Tinta y superficie. Los textos NUNCA llevan el color de la serie. */
export const INK = {
  light: { primary: '#0b0b0b', secondary: '#52514e', muted: '#8a887f', grid: '#e4e3dd', surface: '#fcfcfb' },
  dark: { primary: '#ffffff', secondary: '#c3c2b7', muted: '#8a887f', grid: '#2f2f2d', surface: '#1a1a19' },
} as const;
